/*
 *
 * ContactsPage14326
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import withPrivateRoot from 'containers/App/withPrivateRoot';

import ContactsDxGrid14326 from './ContactsDxGrid14326';

const styleSheet = (theme) => ({
  root: {
    padding: theme.spacing.unit * 2,
    width: '100%',
  },
});

class ContactsPage14326 extends React.PureComponent {
  render() {
    return (
      <div className={this.props.classes.root}>
        <Paper>
          <ContactsDxGrid14326
            key={this.props.viewName}
            viewName={this.props.viewName}
          />
        </Paper>
      </div>
    );
  }
}

ContactsPage14326.propTypes = {
  classes: PropTypes.object,
  viewName: PropTypes.string,
};

export default withPrivateRoot(
  withStyles(styleSheet)(ContactsPage14326)
);
